import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header.js';
import LateralBar from '../dashboard/components/LateralBar.js';
import './styles/MainLayout.css';

// MainLayout component
// The main layout is the main container of the webApp. It contains the header and any other page that is created with.
// It also contains the state for the header, which is passed to the header component as props. So any page that is used with
// the main layout is required to control de header state with the setHeaderExtended and setHeaderAnimated functions.
const MainLayout = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen relative">
      {/* Background orbs */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large firefly glow orb */}
        <div className="absolute -top-120 -left-0 w-[2000px] h-[2000px] rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-slow-bounce firefly-orb-primary"></div>
        <div className="absolute -top-60 -left-0 w-[1000px] h-[1000px] rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-slow-bounce firefly-orb-secondary"></div>
        {/* Small magical light orb */}
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full mix-blend-multiply filter blur-3xl animate-slow-bounce firefly-orb-light"></div>
        {/* Warm firefly ambiance orb */}
        <div className="absolute -bottom-10 -right-40 w-[1000px] h-[1000px] rounded-full mix-blend-multiply filter blur-3xl animate-slow-bounce firefly-orb-accent"></div>
      </div>

      {/* Main content */}
      <div className="relative whole-content">
        <Header isScrolled={isScrolled} />
          <div className="dashboard-elements">
            <Outlet />
        </div>
      </div>
    </div>
  );
};

// We ensure that the children of the main layout are a react element
MainLayout.propTypes = {
};

export default MainLayout;